import React, { useEffect, useState } from 'react';

import AccountService from '../../../../Service/AccountService';
import Swal from 'sweetalert2';

export default function useFetchRecordCashoutDetail(id = null) {
	const [state, setState] = useState({ _isLoading: false, data: [] });

	const setCashoutSource = async () => {
		setState({ _isLoading: true });

		try {
			const response = await AccountService.getRecordCashoutDetail(id);

			setState({ data: response, _isLoading: false });
		} catch (error) {
			setState({ _isLoading: false });
			toastWhenFail(`Error: ${error.message}`);
		}
	};

	const toastWhenFail = resp => {
		Swal.fire({
			allowOutsideClick: false,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt:"Custom Image",
			title: 'Something went wrong!',
			text: resp,
			// icon: 'error',
			customClass: 'otp_message_success',
			
		});
	};

	useEffect(() => {
		setCashoutSource();
	}, [id]);
	return { state };
}
